import { type Dispatch } from 'redux';
import { discardPostSettings } from '../../../common/store/post-settings/discard-post-settings';

export const discardPostSettingsModalResolver = () => (dispatch: Dispatch) => {
  return dispatch(discardPostSettings());
};
